import { Stack, Typography } from '@mui/material'

import CloseIcon from 'assets/icons/CloseGrey.png'

import { InvoiceDialogProps } from '../../invoice.dialog'
import { Close, Container } from './invoice-dialog-list-header.styles'

const InvoiceDialogListHeader = ({
  userInvoiceId,
  handleClose,
}: Omit<InvoiceDialogProps, 'open'> & { userInvoiceId: string }) => {
  return (
    <Container>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Typography fontWeight={700} color="secondary.main">
          {userInvoiceId}
        </Typography>
      </Stack>
      <Close src={CloseIcon} alt="close" onClick={handleClose} />
    </Container>
  )
}

export default InvoiceDialogListHeader
